import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { images } from "./images";

import { mc } from "../characters/MC";
import { V9AnnMorningCallAfter } from "./V9";
import { doWaitImageByTime, isAnnCorrupted, isAnnGF } from "../helpers/helpers";
import { empty } from "../characters/empty";
import { ivy } from "../characters/Ivy";
import { ann } from "../characters/Ann";

export const V9AnnMorningCall = async (): Promise<any> => {

    if (isAnnGF()) {
        if (isAnnCorrupted()) {
            return jump(V9AnnMorningCall_Corrupted, `V9AnnMorningCall_Corrupted`);
        } else {
            return jump(V9AnnMorningCall_LoveWebcam, `V9AnnMorningCall_LoveWebcam`);
        }
    }

    return jump(V9AnnMorningCall_Hate, `V9AnnMorningCall_Hate`);
};

export const V9AnnMorningCall_LoveWebcam = async (): Promise<any> => {
    mc.think(`Ann wants to talk. Let's see if she's available.`);
    doWaitImageByTime(images.v9.V9McMorningSkype_3);
    empty.think(`Dialing.`);
    empty.think(`Dialing..`);
    empty.think(`Dialing...`);
    doWaitImageByTime(images.v9.V9McMorningSkype_3.partials.V9McMorningSkype_4);
    mc.think(`What the... Who is that?`);
    doWaitImageByTime(images.v9.V9AnnDormCallIvy_4);
    mc.talk(`Hey...?`);
    ImageClass.setImage(images.v9.V9AnnDormCallIvy_6);
    ivy.talk(`Hey! You must be ${mc.name}!`);
    ImageClass.setImage(images.v9.V9AnnDormCallIvy_7);
    mc.talk(`Guilty as charged.`);

    ImageClass.setImage(images.v9.V9AnnDormCallIvy_8);
    ivy.talk(`Nice to meet you! I'm Ivy.`);
    ivy.talk(`I'm Ann's roommate.`);

    ImageClass.setImage(images.v9.V9AnnDormCallIvy_6);
    ivy.talk(`I hope it's not rude of me to answer the call...`);
    ivy.talk(`The PC just kept ringing and ringing...`);
    ImageClass.setImage(images.v9.V9AnnDormCallIvy_6);
    await ivy.setQuestion(new Question({ text: "And to be honest... I was a bit curious to see what you look like... Ha.", options: { think: false }, key: `v9AnnMorningCallFlirtedWithIvy` })
        .option({ title: "Flirt with Her", key: true })
        .option({ title: "Don't Flirt", key: false }));

    let anywayOrEmpty = ``;
    if (Question.globalAnswers.v9AnnMorningCallFlirtedWithIvy) {
        await mc.set((properties) => {
            properties.ivyRelationship++;
        });
        ImageClass.setImage(images.v9.V9AnnDormCallIvy_4);
        mc.talk(`Now you see!`);
        mc.talk(`And to be honest, as a medical student like yourself, I suppose I'm going to be sick quite often in the future.`);
        ImageClass.setImage(images.v9.V9AnnDormCallIvy_5);
        ivy.talk(`Ha! Ann said you were funny!`);
        anywayOrEmpty = `Anyway, `;
    }

    ImageClass.setImage(images.v9.V9AnnDormCallIvy_9);
    ivy.talk(`${anywayOrEmpty}Ann had to step out, and I don't know when she'll be back.`);
    ivy.talk(`I'll tell her you called.`);
    ImageClass.setImage(images.v9.V9AnnDormCallIvy_4);
    mc.talk(`Thank you.`);
    ImageClass.setImage(images.v9.V9AnnDormCallIvy_8);
    ivy.talk(`Pool time for me!`);
    if (Question.globalAnswers.v9AnnMorningCallFlirtedWithIvy) {
        ImageClass.setImage(images.v9.V9AnnDormCallIvy_7);
        mc.talk(`I hadn't realized the life of a medical student was that challenging.`);
        ImageClass.setImage(images.v9.V9AnnDormCallIvy_5);
        ivy.talk(`Ha!`);
        ImageClass.setImage(images.v9.V9AnnDormCallIvy_6);
        ivy.talk(`Well... The really hard studying starts if we get accepted... So in the meantime, I want to make the most of it.`);
        ImageClass.setImage(images.v9.V9AnnDormCallIvy_4);
        mc.talk(`Makes sense.`);

    }
    ivy.talk(`It was nice meeting you!`);
    ImageClass.setImage(images.v9.V9AnnDormCallIvy_7);
    await mc.setQuestion(new Question({ text: "Likewise!", options: { think: false }, key: `v9AnnMorningCallLeaveWebcamOn` })
        .option({ title: "Leave the webcam on", key: true })
        .option({ title: "Turn the webcam off", key: false }));

    if (Question.globalAnswers.v9AnnMorningCallLeaveWebcamOn) {
        doWaitImageByTime(images.v9.V9AnnDormCallIvy_11);
        mc.think("Nice! I'm glad I didn't turn off the webcam.");
        doWaitImageByTime(images.v9.V9AnnDormCallIvy_12);
        mc.think("Yeah... Pick that towel up!");
        ImageClass.setImage(images.v9.V9AnnDormCallIvy_10);
        ivy.talk("Oh! You're still here!");
        mc.talk("My computer just unfroze!");
        ImageClass.setImage(images.v9.V9McMorningSkype_3);
        mc.talk("She seems pretty chill. I don't think I'll get into trouble because of that.");
    }


    return jump(V9AnnMorningCallEnd, `V9AnnMorningCallEnd`);
};

export const V9AnnMorningCall_Corrupted = async (): Promise<any> => {
    mc.think(`Ann wanted to talk to me... Let's see if she's free.`);
    ImageClass.setImage(images.v9.V9MorningPhone);
    mc.think(`*Dialing Ann*`);
    ann.talk(`Hey ${mc.name}!`);
    mc.talk(`Hey! You mentioned wanting to talk? It sounded important.`);
    ann.talk(`I do, and it is!`);
    ann.talk(`But I'd rather do it in person.`);
    ann.talk(`When can we meet?`);
    mc.talk(`I have some things to do today, but I'm free in the evening.`);
    ann.talk(`Great! I'll drop by then.`);
    mc.talk(`Are you sure? I can clear my schedule if it's that important.`);
    ann.talk(`It can wait, no rush!`);
    mc.talk(`Alright, see you later.`);
    ann.talk(`Muah!`);

    return jump(V9AnnMorningCallEnd, `V9AnnMorningCallEnd`);
};

export const V9AnnMorningCall_Hate = async (): Promise<any> => {

    return jump(V9AnnMorningCallEnd, `V9AnnMorningCallEnd`);
};

export const V9AnnMorningCallEnd = async (): Promise<any> => {

    return jump(V9AnnMorningCallAfter, `V9AnnMorningCallAfter`);
};
